<!-- 球队管理 -->
<template>
    <div>
        <event-head></event-head>
        <div class="mt-3">
            <el-table :data="personinfo" style="width: 100%" :header-cell-style="{
                color: '#fff',
                fontSize: '14px',
                height: '40px',
                width: '100%',
            }">
                <el-table-column prop="title" label="标题" align="center" width=""></el-table-column>
                <el-table-column prop="txt" label="文本" align="center"></el-table-column>
                <!-- <el-table-column prop="website" label="公司官网" align="center"></el-table-column>
                <el-table-column prop="email" label="公司邮箱" align="center"></el-table-column>
                <el-table-column prop="phone" label="客服电话" align="center"></el-table-column>
                <el-table-column prop="mobile" label="联系电话" align="center"></el-table-column>
                <el-table-column prop="address" label="联系地址" align="center"></el-table-column>
                <el-table-column label="技术微信" align="center">
                    <template slot-scope="scope">
                        <el-image :src="scope.row.wechat" style="width: 100px;height:100px"
                            @click="editLogo(scope.row)"></el-image>
                    </template>
                </el-table-column>
                <el-table-column label="企业微信" align="center">
                    <template slot-scope="scope">
                        <el-image :src="scope.row.companywechat" style="width: 100px;height:100px"
                            @click="editLogo(scope.row)"></el-image>
                    </template>
                </el-table-column> -->
            </el-table>
            <!-- <el-pagination layout="total, prev, pager, next" :current-page="pageInfo.page"
            :page-size="pageInfo.pageSize" :total="pageInfo.count"
            @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination> -->
        </div>
    </div>
</template>

<script>
import EventHead from '@/common/components/eventHead/EventHead';
export default {
    components: {
        EventHead
    },
    data() {
        return {
            pageInfo: {
                page: 1,
                pageSize: 10,
                count: 0,
            },
            personinfo:[{
                title:'詹大炮',
                txt:'我的家在东北松花江上啊，那里有满山遍野大豆高粱  在那青山绿水旁  门前两棵大白杨齐整整的篱笆院  一间小草房啊  哎哟  我爸爸有事没事总想喝点酒  就算是没有菜那也得喝二两大碗茶大碗的酒左邻右舍在两旁  五魁首六六六笑声满堂啊  哎哟  我妈妈从小嗓门就亮啊  每天她唱'
            },
        {
                title:'詹大炮',
                txt:'198-9521-9954'
            },
        {
                title:'詹大炮',
                txt:'198-9521-9954'
            },
        {
                title:'詹大炮',
                txt:'198-9521-9954'
            },
        {
                title:'詹大炮',
                txt:'198-9521-9954'
            },]

        };
    },
    mounted() {

    },
    methods: {


        handleSizeChange(val) {
            this.pageInfo.pageSize = val;
        },
        handleCurrentChange(val) {
            this.pageInfo.page = val;
        },

    },
};
</script>

<style lang="scss" scoped>
.cardinal {
    margin-top: 30px;
}

.addMatch {
    margin-left: 30px;
    font-size: 16px;
    color: #000;

}

/deep/.el-input--small .el-input__inner {
    height: 32px;
    line-height: 32px;
    background-color: transparent;
    opacity: 1;
    border: none;
    border-bottom: 1px solid #9b9b9b;
    color: #fff;
    border-radius: 0;
}

.bottom_btn {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-top: 10px;

    .addVenue {
        color: #fff;
    }
}
</style>